import type { ReactElement } from "react";

import { InclusionFilterResult } from "app/pages/sales-intelligence/common-components/filters-panel/components/InclusionFilterResult/InclusionFilterResult";
import { INDUSTRIES_CODE_NAMES, industryCodeDtoMap } from "app/pages/sales-intelligence/domain/industry/types/codes";
import {
    getIndustryCodesConditionKey,
    hasSameIndustryCodesObject,
} from "app/pages/sales-intelligence/domain/industry/utils/operations";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type IndustryCodesFilterModel from "../../../models/IndustryCodesFilter/IndustryCodesFilterModel";
import industryCodesFilterTrackingService from "../../../services/tracking/industry-codes-filter/trackingService";

import InclusionIndustryCodesChip from "./InclusionIndustryCodesChip/InclusionIndustryCodesChip";
import { IndustryCodesModal } from "./modals/IndustryCodesModal/IndustryCodesModal";

const IndustryCodesFilterResult = ({
    value = [],
    filter,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<IndustryCodesFilterModel>): ReactElement | null => {
    const { codeOptions, options } = filter;
    const { naicsCode: naicsCodes, sicCodes } = options;

    return (
        <InclusionFilterResult
            value={value}
            isActionEnabled={isActionEnabled}
            onGetLifecycleStatus={onGetLifecycleStatus}
            onFilterUpdate={onFilterUpdate}
            onFilterValueRemove={onFilterValueRemove}
            hasSameObject={hasSameIndustryCodesObject}
            getConditionKey={getIndustryCodesConditionKey}
            onDeleteCondition={(selectedItem) => {
                if (selectedItem.sicCodes.length > 0) {
                    industryCodesFilterTrackingService.trackingIndustryCodesChange(
                        INDUSTRIES_CODE_NAMES[industryCodeDtoMap.sic],
                        "remove",
                    );
                }
                if (selectedItem.naicsCodes.length > 0) {
                    industryCodesFilterTrackingService.trackingIndustryCodesChange(
                        INDUSTRIES_CODE_NAMES[industryCodeDtoMap.naics],
                        "remove",
                    );
                }
            }}
            renderModal={({ isOpen, selectedItem, onClose, onCancel, onApply }) => (
                <IndustryCodesModal
                    isOpen={isOpen}
                    selected={selectedItem}
                    value={value}
                    codeOptions={codeOptions}
                    naicsCodes={naicsCodes}
                    sicCodes={sicCodes}
                    isExcludeAvailable={filter.isExcludeInclusionAvailable(value, selectedItem)}
                    onClose={onClose}
                    onCancel={onCancel}
                    onApply={onApply}
                />
            )}
            renderChip={({ item, hideActionButton, onEdit, onDelete }) => (
                <InclusionIndustryCodesChip
                    item={item}
                    hideActionButton={hideActionButton}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            )}
        />
    );
};

export default IndustryCodesFilterResult;
